/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import {accounting} from 'accounting'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import $ from 'jquery'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import FromToPicker from '../BaseComponent/FromToPicker'

class WithOutSettleDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      settlements: [],
      printInfo: [],
      fromDate: '',
      toDate: '',
      planMax: '',
      planMin: ''
    }
  }

  getAllWithOutSettlements = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_WITHOUTSETTLEMENT
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            settlements: response.data.object.result,
            countAll: response.data.object.countAll
          })
          $('.showBaseTable,.print').fadeIn()
        } else {
          this.setState({
            settlements: [],
            countAll: ''
          })
          $('.showBaseTable,.print').fadeOut()
        }
      })
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })
    })

    // this.getAllWithOutSettlements()
  }

  changeDropDown(data) {
    this.setState({
      settlements: data,
      lengthProducts: this.state.total
    })
  }

  onResultFetched(data) {
    this.setState({
      settlements: data
    })
  }
  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  changePlanFrom = (planMin) => {
    this.setState({
      planMin
    })
  }
  changePlanTo = (planMax) => {
    this.setState({
      planMax
    })
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_WITHOUTSETTLEMENT
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['creationTime'] !== null) {
              excelReport[i]['creationTime'] = jMoment(excelReport[i]['creationTime']).format('jYY/jMM/jDD HH:mm')
            } else {
              excelReport[i]['creationTime'] = ''
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_WITHOUTSETTLEMENT}?export=true&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }
  filter() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    let planDateMin = this.state.planMin
    let planDateMax = this.state.planMax

    if (planDateMax === '' && planDateMin === '' && maxDate === '' && minDate === '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ تسویه ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ تسویه انتها صحیح نیست')
    } else if ((planDateMin != '' || planDateMin == null) && isNaN(planDateMin)) {
      message.error('فرمت تاریخ توزیع ابتدا صحیح نیست')
    } else if ((planDateMax != '' || planDateMax == null) && isNaN(planDateMax)) {
      message.error('فرمت تاریخ توزیع انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD')
      })
      sessionStorage.setItem('pageNumber', '1')
      sessionStorage.setItem('dropDownVal', '10')
      sessionStorage.setItem(
        'params',
        `planDateMax=${planDateMax}&planDateMin=${planDateMin}&settlementTimeMin=${minDate}&settlementTimeMax=${maxDate}`
      )
      this.getAllWithOutSettlements()
    }
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'نام', 'نام خانوادگی']
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش رساننده های بدون سند تسویه"
              headerColSpan={3}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((drivers, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{drivers.firstName}</td>
                  <td>{drivers.lastName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش رساننده های بدون سند تسویه.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'firstName'}
                field={'firstName'}
                title={'نام'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'lastName'}
                field={'lastName'}
                title={'نام خانوادگی'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>تسویه رساننده</li>
            <li>گزارش رساننده های فاقد سند تسویه</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/financial/settlement"
                  url={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_WITHOUTSETTLEMENT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_WITHOUTSETTLEMENT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.changePlanFrom}
                  onChangeToDate={this.changePlanTo}
                  fromLabel="تاریخ توزیع از"
                  toLabel="تاریخ توزیع تا"
                  defaulValue={true}
                  fromId="planMin"
                  toId="planMax"
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تسویه از"
                  toLabel="تاریخ تسویه تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام</td>
                    <td>نام خانوادگی</td>
                  </tr>
                  {this.state.settlements.map((drivers, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{drivers.firstName}</td>
                      <td>{drivers.lastName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  urlParams={sessionStorage.getItem('params')}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_WITHOUTSETTLEMENT}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default WithOutSettleDrivers
